import container from './container'

const HotelMappingInfo = () => {
    return null
}

export default container(HotelMappingInfo)
